<p-dialog [(visible)]="visible" [modal]="true" [style]="{ 'max-width': '700px', width: '100%' }" header="Update Parent">
    <p-scrollPanel>
        <ng-container *ngIf="nodes$ | async as nodes">
            <ng-container *miproLoading="nodes === 'loading'">
                <p-tree [value]="nodes" [(selection)]="selectedNode" selectionMode="single" title="Main Menu" scrollHeight="flex">
                    <ng-template let-node pTemplate="default">
                        <div class="flex align-items-center" [title]="node.data.routerLink">
                            <i *ngIf="node.data.miproIcon" class="mi mr-2">{{ node.data.miproIcon }}</i>
                            <i *ngIf="!node.data.miproIcon && node.data.icon" class="material-icons mr-2">{{ node.data.icon }}</i>
                            <span>{{ node.data.label }}</span>
                        </div>
                    </ng-template>
                </p-tree>
            </ng-container>
        </ng-container>
    </p-scrollPanel>

    <ng-template pTemplate="footer">
        <form-buttons [config]="formButtonsConfig" [saving]="updatingParent"></form-buttons>
    </ng-template>
</p-dialog>
